import { GEO_BY_IP_FETCH_ERROR } from '@/entities/geo/lib/geoMessages';
import {
  GEO_LOCATION_COOKIE_NAME,
  GEO_LOCATION_COOKIE_MAX_AGE,
} from '@/shared/constants/cookiesConstants';
import type { GeoLocationData } from '@/entities/geo/model/types/geo';
import { logError, normalizeError } from '@/shared/lib/errors';

export const useGeoLocation = () => {
  const { $geoService } = useNuxtApp();

  const geoCookie = useCookie<GeoLocationData | undefined>(GEO_LOCATION_COOKIE_NAME, {
    path: '/',
    maxAge: GEO_LOCATION_COOKIE_MAX_AGE,
  });

  const getGeoSlug = async (): Promise<string> => {
    if (geoCookie.value !== undefined) return geoCookie.value?.slug ?? '';

    try {
      const { data } = await $geoService.getGeoByIp<{
        data: GeoLocationData | GeoLocationData[];
      }>();
      const location = Array.isArray(data) ? {} : data;

      geoCookie.value = location;
      return location?.slug ?? '';
    } catch (error) {
      logError(normalizeError(error), { action: GEO_BY_IP_FETCH_ERROR });
      return '';
    }
  };

  return { geoCookie, getGeoSlug };
};
